export default {
  state:{
    count:0
  },
  mutations:{

  },
  actions: {

  }

}



// WEBPACK FOOTER //
// ./src/store/head2.js